export default class OrderCsvGenerator {
  constructor(config) {
    this.$container = config.$container;
    this.zipUrl = undefined;
    this.contactFileName = undefined;
    this.exportId = config.exportId;
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    this.$container.hide();
    this.pollEndpoint();
  }

  pollEndpoint() {
    if (this.zipUrl) {
      if (this.$container.is(":visible")) return;

      console.log(this.count)
      $('#loading-message').hide();
      this.$container.show();
      $('#contact-length').html(this.count);

      return;
    }

    $.get(`/admin/orders/waiting.json?export_id=${this.exportId}`, (data) => {
      this.zipUrl = data.url;
      this.fileName = data.file_name;
      this.count = data.count;
      setTimeout(this.pollEndpoint.bind(this), 2500);
    });
  }
}
